var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.simplePage && _vm.simplePage.title)?_c('SimplePage',{attrs:{"text":_vm.simplePage.text,"title":_vm.simplePage.title,"img":_vm.base_url + _vm.simplePage.capa,"photos":_vm.simplePage.imgs}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }